import React from 'react';


const AdditionalContent = () => {
  return (
    <section className="section">
        <div className="columns is-centered">
          <div className="column is-8">
            <div className="content is-medium">
              <p className="has-text-centered">
                Additional content includes activities, downloadable PDF
                content, and conversation starters.
              </p>
            </div>
        </div>
      </div>
    </section>
  );
};

export default AdditionalContent;
